import React, { useState } from "react";
import { handleLogin, invokeZCBot, gotoHeaderPromotions, handleRegister } from "../../utils/common";
import { AppContext } from "../../store";
import { useNavigate } from "react-router-dom";
import chatImg from "../../images/chat.svg";
import { Dropdown, Space, Checkbox, message } from "antd";
import {
  CaretDownOutlined,
  UserOutlined,
  MailOutlined,
  BankOutlined,
  NumberOutlined,
  EnvironmentOutlined,
  ShoppingCartOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import config, {
  DUMMY_EMAIL_DOMAIN,
  ORDER_CHANNEL,
  SESSION_STORAGE_KEY_MAP,
  USER_TYPE,
  ACTIVITY_NO_PERMISSION_ST_STATUS_LABEL,
  stockCenterAdminLoginUrl,
  stockCenterSelectCustomerUrl,
  stockCenterUserCenterUrl,
} from "../../utils/constant";
import { getSelectedSTObj, getSwithcSTAddress, getContactName, getContactPhone } from "../../utils/addressUtils";
import { logOperation } from "Utils/operationLogUtils";
import cookie from "js-cookie"
import UserIcon from "../../components/icons/userIcon";

interface ShipToItem {
  shipTo: string;
  name: string;
  phone: string;
  addressStr: string;
  isDefault: boolean;
  addressKey: string;
  disabled?: boolean;
}
interface ChildComponentProps {
  page?: string;
  children?: React.ReactNode;
  onRefreshData?: () => void; // 定义 onRefresh 属性的类型
  showSTSelector?: boolean;
  setShowSTSelector?: (show: boolean) => void;
  onSTClick?: (item: ShipToItem, preSt?: string | null) => void;
}
const Header: React.FC<ChildComponentProps> = (props) => {
  const navigate = useNavigate();
  const { loginState, setSelectedAddressKey } = React.useContext(AppContext);
  const [shipToList, setShipToList] = useState<any>([]);
  const allShipToBillToAddresses = loginState?.user?.allShipToBillToAddresses;
  const { onRefreshData, page } = props;
  const addressMenuRef = React.createRef<HTMLSpanElement>();
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const userInfo = loginState?.user?.user;
  const orderChannel = loginState?.proxyUser?.orderChannel;
  const currentShipTo = getSelectedSTObj(loginState);
  const customerName =
    `${userInfo?.lastName || ""}${userInfo?.firstName || ""}` || "";
  const customerEmail =
    userInfo?.userName ||
    userInfo?.contactInfo?.primaryEmail ||
    "";
  const customerCompany =
    currentShipTo?.companyOrInstitution ||
    "";
  const customerStNumber =
    currentShipTo?.accountNumber ||
    "";
  const customerAddress = currentShipTo
    ? getSwithcSTAddress(currentShipTo)
    : "";
  const employeeEmail = loginState?.proxyUser?.email || "";
  const loginDisplayName = loginState?.proxyUser?.username || "";
  const customerLoginDisplayName =
    `${userInfo?.lastName || ""}${userInfo?.firstName || ""}`;
  const isLoggedIn = loginState?.status === "login";
  const isDummyCustomer = userInfo?.userName?.includes(DUMMY_EMAIL_DOMAIN);
  let pageTitle = '组合购专区';
  if (orderChannel === ORDER_CHANNEL.ONLINE) {
    pageTitle = "组合购 - 预购单";
  } else if (orderChannel === ORDER_CHANNEL.OFFLINE) {
    pageTitle = "组合购 - 上传凭证入单";
  }

  const getALLShipToList = () => {
    let allShipToList: ShipToItem[] = [];
    let tempAllShipToBillToAddresses = JSON.parse(JSON.stringify(allShipToBillToAddresses));
    if (tempAllShipToBillToAddresses && tempAllShipToBillToAddresses.length > 0) {
      tempAllShipToBillToAddresses.map((shipToBillToItem: any) => {
        let shipItem1 = shipToBillToItem.shipTo;

        allShipToList.push({
          shipTo: shipItem1.accountNumber,
          name: getContactName(shipItem1, loginState.user),
          phone: getContactPhone(shipItem1, loginState.user),
          addressStr: getSwithcSTAddress(shipToBillToItem.shipTo),
          isDefault: shipToBillToItem.shipTo.isDefault,
          addressKey: shipToBillToItem.shipTo.addressKey,
          disabled: shipToBillToItem.shipTo.disabled,
        });
      });
    }
    setShipToList(allShipToList);
  };
  const handleMouseEnter = () => {
    getALLShipToList();
  };

  const handleShipToChange = (item: ShipToItem) => {
    if (item.disabled) {
      message.warning(ACTIVITY_NO_PERMISSION_ST_STATUS_LABEL);
      return;
    }
    const currentAddressKey = getSelectedSTObj(loginState)?.addressKey?.toString();
    if (currentAddressKey === item.addressKey?.toString()) {
      return;
    }
    const preSelectedSTObj = getSelectedSTObj(loginState);
    let preSelectedAddressKey = localStorage.getItem("selectedAddressKey");
    if (!preSelectedAddressKey) {
      preSelectedAddressKey = preSelectedSTObj?.addressKey;
    }
    localStorage.setItem("selectedAddressKey", item.addressKey);
    setSelectedAddressKey(item.addressKey?.toString());
    const opTargetId =
      (preSelectedSTObj?.accountNumber || preSelectedSTObj?.addressKey) +
      "," +
      (item?.shipTo || item?.addressKey);
    logOperation({
      opUser: userInfo?.userId,
      opTarget: "Exchange_ST",
      opTargetId: opTargetId,
      opContent: page,
    });
    onRefreshData?.();
    if (props.onSTClick) {
      props.onSTClick(item, preSelectedAddressKey);
    }
  };

  const setMyAccount = () => {
    window.open(
      `${config.REGISTER_API_ENDPOINT}/store/v2/account-center/my-account/profile`,
      "_blank"
    );
  };

  const getCurrentActivityId = () => {
    return  (window as any).currentCampaignId || '';
  }

  const handleLogout = async () => {
    const rest = await logOperation({
      opUser: userInfo?.userId,
      opTarget: 'Logout',
      opTargetId: '',
      opContent: page,
    })  
    localStorage.removeItem("selectedAddressKey");
    localStorage.removeItem("authToken");
    cookie.remove("token")
    let currentActivityId = getCurrentActivityId();
    localStorage.removeItem("currentCampaignId");
    const backUrl = `${
      config.APPLICATION_ENDPOINT
    }/campaigns/${currentActivityId}`;

    const logoutUrl = `${config.REGISTER_API_ENDPOINT}/auth/logout?ReturnURL=${backUrl}`;
    window.location.href = logoutUrl;
  };
  
  return (
    <div className="App-headerWrapper">
      <header className="pageContentContainer App-header">
        <div className="App-head">
          <img
            src={process.env.PUBLIC_URL + `/logo.svg`}
            className="App-logo"
            alt="logo"
            onClick={() => {
              window.location.href = "https://www.thermofisher.cn/cn/zh/home.html"
            }}
          />
          <span className="App-pageTitleDivider" />
          <div 
            className="App-pageTitle"
            style={{cursor: !isEmployee ? 'pointer' : undefined}}
            onClick={() => {
              if (!isEmployee) {
                gotoHeaderPromotions(loginState)
              }
            }}
          >
            {pageTitle}
          </div>
        </div>
        <div className={`App-headright${isEmployee ? " App-headright-employee" : ""}`}>
          {isEmployee 
            ? <>
                {isLoggedIn && <><Dropdown
                    trigger={["click"]}
                    placement="bottom"
                    popupRender={() => (
                      <div className="employeeCustomerCard">
                        <div className="employeeCustomerCardTitle">客户详细信息</div>
                        {!isDummyCustomer && (
                          <>
                            <div className="employeeCustomerInfoItem">
                              <span className="employeeCustomerInfoIcon" style={{position: 'relative', left: '-2px'}}>
                                <UserIcon width={18} height={18} />
                              </span>
                              <div>
                                <div className="employeeCustomerInfoLabel">客户姓名</div>
                                <div className="employeeCustomerInfoValue">{customerName}</div>
                              </div>
                            </div>
                            <div className="employeeCustomerInfoItem">
                              <MailOutlined className="employeeCustomerInfoIcon" />
                              <div>
                                <div className="employeeCustomerInfoLabel">Login Account</div>
                                <div className="employeeCustomerInfoValue">{customerEmail || "-"}</div>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="employeeCustomerInfoItem">
                          <BankOutlined className="employeeCustomerInfoIcon" />
                          <div>
                            <div className="employeeCustomerInfoLabel">公司名称</div>
                            <div className="employeeCustomerInfoValue">{customerCompany || "-"}</div>
                          </div>
                        </div>
                        <div className="employeeCustomerInfoItem">
                          <NumberOutlined className="employeeCustomerInfoIcon" />
                          <div>
                            <div className="employeeCustomerInfoLabel">ST Number</div>
                            <div className="employeeCustomerInfoValue">{customerStNumber || "-"}</div>
                          </div>
                        </div>
                        <div className="employeeCustomerInfoItem">
                          <EnvironmentOutlined className="employeeCustomerInfoIcon" />
                          <div>
                            <div className="employeeCustomerInfoLabel">收货地址</div>
                            <div className="employeeCustomerInfoValue">{customerAddress || "-"}</div>
                          </div>
                        </div>
                      </div>
                    )}
                  >
                    <div className="employeeCustomerTrigger">
                      <span style={{position: 'relative', left: '2px', top: '1px'}}>
                        <UserIcon color="#333" />
                      </span>
                      <span className="employeeCustomerTriggerLabel">客户:</span>
                      <span className="employeeCustomerTriggerName">
                        {isDummyCustomer
                          ? customerStNumber
                          : customerName || customerStNumber}
                      </span>
                      <CaretDownOutlined className="employeeCustomerTriggerArrow" />
                    </div>
                  </Dropdown>
                  <span className="employeeHeaderDivider" />
                  <Dropdown
                    trigger={["click"]}
                    placement="bottomRight"
                    popupRender={() => (
                      <div className="employeeAccountCard">
                        <div className="employeeAccountHeader">
                          <div className="employeeAccountMeta">
                            <div className="employeeAccountName">{loginDisplayName}</div>
                            <div className="employeeAccountEmail">{employeeEmail || "-"}</div>
                          </div>
                        </div>
                        <button
                          type="button"
                          className="employeeAccountAction"
                          onClick={() => {
                            window.location.href = stockCenterUserCenterUrl;
                          }}
                        >
                          <span className="employeeAccountActionMain">
                            <UserOutlined style={{fontSize: 15}} className="employeeAccountActionIcon" />
                            <span>个人信息</span>
                          </span>
                        </button>
                        <button
                          type="button"
                          className="employeeAccountAction"
                          onClick={() => {
                            window.location.href = stockCenterSelectCustomerUrl;
                          }}
                        >
                          <span className="employeeAccountActionMain">
                            <ShoppingCartOutlined className="employeeAccountActionIcon" style={{ fontSize: 16, position: "relative", left: "-2px" }} />
                            <span>客户列表</span>
                          </span>
                        </button>
                        <button
                          type="button"
                          className="employeeAccountAction"
                          onClick={() => {
                            sessionStorage.removeItem(SESSION_STORAGE_KEY_MAP.AUTH_TOKEN)
                            window.location.href = stockCenterAdminLoginUrl;
                          }}
                        >
                          <span className="employeeAccountActionMain">
                            <ExportOutlined style={{fontSize: 13 }} className="employeeAccountActionIcon" />
                            <span>退出</span>
                          </span>
                        </button>
                      </div>
                    )}
                  >
                    <div className="employeeAccountTrigger">
                      <span className="employeeAccountTriggerName">{loginDisplayName}</span>
                      <CaretDownOutlined className="employeeAccountTriggerArrow" />
                    </div>
                  </Dropdown>
                </>}
              </> 
            : <>{isLoggedIn && (
            <Dropdown
              menu={{
                triggerSubMenuAction: "click",
                onOpenChange(openKeys) {
                  if (openKeys.length > 0 && openKeys[0] === "0") {
                    props.setShowSTSelector?.(false);
                  }
                },
                items: [
                  {
                    label: (
                      <span ref={addressMenuRef}>切换收货地址</span>
                    ),
                    key: "0",
                    onMouseEnter: handleMouseEnter,
                    children: shipToList?.map((item: any, index: any) => {
                      const selectedSTObj = getSelectedSTObj(loginState);
                      return {
                      label: (
                        <div
                          className="switch-shipto-header-container"
                          style={{
                            padding: "0px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            opacity: item.disabled ? 0.45 : 1,
                            borderBottom: "1px solid #ccc",
                            paddingBottom: "10px",
                            cursor: item.disabled ? "not-allowed" : "pointer",
                          }}
                        >
                          <div
                            style={{ paddingRight: "5px" }}
                            onClick={() => {
                              handleShipToChange(item);
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "8px" }}
                            >
                              <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
                                <span
                                  className="switch-shipto-header-checkbox"
                                  style={{ display: "inline-flex", cursor: item.disabled ? "not-allowed" : "pointer" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleShipToChange(item);
                                  }}
                                >
                                  <Checkbox
                                    disabled={item.disabled}
                                    checked={
                                      (item.addressKey.toString() === selectedSTObj?.addressKey.toString())
                                        ? true
                                        : false
                                    }
                                    style={{ pointerEvents: "none" }}
                                  ></Checkbox>
                                </span>
                                <div
                                  style={{
                                    color: "#1B1B1D",
                                    fontWeight: "600",
                                    fontFamily: "Source Han Sans CN",
                                    margin: "0 8px 0 2px",
                                    fontSize: "16px",
                                    whiteSpace: "nowrap",
                                    flexShrink: 0,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {item.name}
                                </div>
                                <div style={{ 
                                  color: "#aeaeae", 
                                  wordBreak: "break-all",
                                  flex: "1 1 auto",
                                  minWidth: 0,
                                  display: "flex",
                                  alignItems: "center",
                                }}>
                                  {item.phone}
                                </div>
                                {item.isDefault && (
                                  <div
                                    style={{
                                      background: "#70707A",
                                      border: "1px solid #70707A",
                                      borderRadius: "10px",
                                      color: "#FFFFFF",
                                      fontSize: "10px",
                                      padding: "2px 5px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexShrink: 0,
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    默认
                                  </div>
                                )}
                              </div>
                            </div>
                            <div
                              style={{
                                fontSize: "13px",
                                marginTop: "10px",
                                color: "#70707A",
                              }}
                            >{`${item.addressStr}`}</div>
                          </div>
                        </div>
                      ),
                      key: index,
                    }}),
                  },
                  {
                    label: <span>设置我的账号</span>,
                    key: "1",
                    onClick: setMyAccount,
                  },
                  {
                    label: <span>退出登录</span>,
                    key: "2",
                    onClick: handleLogout,
                  },
                ],
              }}
              trigger={["click"]}
            >
              <Space>
                {customerLoginDisplayName}
                <CaretDownOutlined
                />
              </Space>
            </Dropdown>
          )}</>
          }
          {loginState?.status !== "login" && (
            <span onClick={handleLogin}>用户登录</span>
          )}
          {loginState?.status !== "login" && (
            <span onClick={handleRegister}>注册</span>
          )}
          {!isEmployee && (
            <div style={{ margin: "0px 8px" }}>
              {" "}
              <img
                style={{ verticalAlign: "middle" }}
                //
                src={chatImg}
                alt="chat"
                data-analytics-location="chat:header:chat-icon"
                data-chat-support-type="overall"
                data-analytics-track-now="true"
                onClick={() => {
                  invokeZCBot(
                    {
                      payload: {
                        empid: userInfo?.cdcUid || "",
                        email: userInfo?.userName || "",
                        firstName: userInfo?.firstName || "",
                        lastName: userInfo?.lastName || "",
                        // gaCid: user.GA_CID,
                        location: window.location.href,
                        country: userInfo?.country || "cn",
                        tel: userInfo?.contactInfo?.phone || "",
                        // company: user.info ? getSelectedShipTo(user)?.shipToAddress?.companyOrInstitution : ''
                      },
                    },
                    navigate
                  );
                }}
              />
            </div>
          )}
        </div>
      </header>
    </div>
  );
};
export default Header;
